import { isURL } from '../../validationHelper';
import { profile as profileConstants } from '../../constants';

export function getMakrwatchPublicationUrl(publication) {
    let url = null;
    if(publication.medium_publication_id && !publication.medium_publication_id.startsWith('not-found-')) {
        url = 'https://search.makrwatch.com/youtube/video/' + publication.medium_publication_id;
    }
    return url;
}

export function getPublicationUrl(publication) {
    let url = null;
    if(publication.medium_publication_id && !publication.medium_publication_id.startsWith('not-found-')) {
        url = publication.channel.medium.publication_url_prefix + publication.medium_publication_id;
    }
    return url;
}

export function getMakrwatchChannelUrl(publication) {
    let url = null;
    if(publication.medium_channel_id !== profileConstants.NOT_FOUND) {
        url = 'https://search.makrwatch.com/youtube/' + publication.channel.medium_channel_id;
    }
    return url;
}

export function getAccountManagerName(publication) {
    let result = '';
    if(publication.account_manager) {
      result = publication.account_manager.name;
  
      if(publication.account_manager2) {
        result += ', ' + publication.account_manager2.name;
      }
    }
    return result;
}

export function convertPublications(receivedPublications) {
    const result = receivedPublications.map(publication => (
        {
            channelName: publication.channel ? publication.channel.name : '',
            channelMediumId: publication.channel ? publication.channel.medium_channel_id : '',
            date: convertPublicationDate(publication.date),
            publicationStatusName: publication.publication_status.name,
            price: publication.price,
            partnerName: publication.partner ? publication.partner.name: '',
            partnerId: publication.partner_id,
            accountManagerName: getAccountManagerName(publication),
            customerSequence: publication.customer_sequence,
            makrwatchChannelUrl: getMakrwatchChannelUrl(publication),
            makrwatchPublicationUrl: getMakrwatchPublicationUrl(publication),
            publicationUrl: getPublicationUrl(publication),
            customerPublicationId: publication.customer_publication_id,
            performanceMetrics: publication.performance_metrics,
            medium: publication.channel ? publication.channel.medium : null
        }
    ));
    return result;
}

export function convertUpcomingPublications(receivedUpcomingPublications) {
    const result = receivedUpcomingPublications.map(upcomingPublication => (
        {
            channelName: upcomingPublication.channel ? upcomingPublication.channel.name : '',
            channelMediumId: upcomingPublication.channel ? upcomingPublication.channel.medium_channel_id : '',
            date: convertPublicationDate(upcomingPublication.publication_date),
            publicationStatusName: upcomingPublication.publication_status.name,
            price: upcomingPublication.price,
            budgetName: upcomingPublication.budget ? upcomingPublication.budget.name: '',
            budgetId: upcomingPublication.budget_id,
            tenantId: upcomingPublication.tenant_id,
            medium: upcomingPublication.channel ? upcomingPublication.channel.medium : null
        }
    ));
    return result;
}

export function extractTokenForSearch(originalSearchText) {
    let result = originalSearchText;
    if(isURL(originalSearchText)) {
        const url = new URL(originalSearchText);
        
        //Check if there a param
        if(url.search) {
            const id = url.searchParams.get('v');
            if(id) result = id;
        } else if (url.pathname) {
            const path = url.pathname;
            result = path.slice(path.lastIndexOf('/') + 1);
        }
    }
    return result;
}

export function normalizeSortConfig(sortObject) {
    const result = {
        sortField: sortObject.field,
        sortDirection: sortObject.dir === 'asc' ? 'ascending': 'descending'
    };
    return result;
}

function convertPublicationDate(dateString) {
    const [year, month, day] = dateString.split('-');
    return new Date(year, parseInt(month) - 1, day);
}